import axios from 'axios';
import { getProductById } from './ProductService';

const APIURL = "https://sonapi.nantech.az/api";

export const getFavoriteProducts = async () => {
  try {
    const response = await axios.get(`${APIURL}/Favorites/list`,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching favorite products:', error.response?.data || error.message);
    throw error; 
  }
};

export const addToFavorite = async (productId) => {  
  try {
    const response = await axios.post(`${APIURL}/Favorites/${productId}`, {
    }, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      }
    });

    return response.data; 
  } catch (error) {
    console.error('Error adding to favorites:', error.response?.data || error.message);
    throw error; 
  }
};

export const removeFromFavorite = async (productId) => {
  console.log(productId);
  console.log(localStorage.getItem("accessToken"));
  const token =localStorage.getItem("accessToken")
  
  try {
    const response = await axios.delete(`https://sonapi.nantech.az/api/Favorites/${productId}`,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    });
    return response.data; 
  } catch (error) {
    console.error('Error removing from favorites:', error.response?.data || error.message);
    throw error; 
  }
};
